<template>

  <portlet
      :icon="'fal fa-chart-pie portlet-icon'"
      :title="$t('oeeAnalytics.performance.title')"
      :actions-block="true"
      :fullheight="true"
      class="portlet-pt-20 oee-chart-portlet"
  >
    <template slot="actionsBlock">

      <div class="row oee-controls">
        <div class="col-6" v-if="filters.selectedDate">
          <label for="">Selected date</label><br>

          <button class="btn btn-info form-control" @click="filters.selectedDate = null"><i
              class="fas fa-undo float-right"></i> {{ parsedSelectedDate }}
          </button>
        </div>
        <div :class="filters.selectedDate ? 'col-6' : 'col-12'">
          <label for="selected-product-number">{{ $t('oeeAnalytics.performance.productNumber') }}</label>
          <select @change="productNumberSelected($event)" name="" class=form-control :value="getSelectedProductNumber"
                  id="selected-product-number">
            <option :value="null">All</option>
            <option v-bind:key="productNumber" v-for="productNumber in getProductNumbersToView" :value="productNumber">
              {{ productNumber }}
            </option>
          </select>
        </div>

      </div>
    </template>
    <template slot="portletBody">
      <div class="row">
        <div class="col-sm-12 col-md-8">
          <template>
            <LineSpeed
                v-if="!loading"
                @dateSelected="setSelectedDate($event)"
                :selectedDate="filters.selectedDate"
                :hardwareLogs="getLogs"
            />

            <ComponentLoadSpinnerV2 v-else :loading="loading"/>
          </template>


        </div>
        <div class="col-sm-12 col-md-4">
          <template class="w-100">
            <TopBottom v-if="getProductionRunData" :uniqueProductNumbers="getProductNumbersToViewFromRuns"
                       @productNumberSelected="setSelectedProductNumber($event)"/>
            <ComponentLoadSpinnerV2 v-else :loading="true"/>
          </template>
        </div>


      </div>


    </template>
  </portlet>


</template>

<script>
import LineSpeed from '@/components/oeeAnalytics/components/performance/LineSpeed'
import TopBottom from '@/components/oeeAnalytics/components/performance/TopBottom'

import ComponentLoadSpinnerV2 from "@/components/general/ComponentLoadSpinnerV2";
import {mapGetters} from "vuex";

export default {
  name: "Performance",
  props: ['productionRuns', 'updateDataTrigger'],
  components: {
    LineSpeed,
    TopBottom,
    ComponentLoadSpinnerV2
  },
  data() {
    return {
      loading: true,
      filters: {
        productNumber: null,
        selectedDate: null
      },
      hardwareLogs: null,
      hardwareLogsPerMinute: {},
      bdr: null,
    }
  },
  computed: {
    ...mapGetters('company', ['getBdrTimeFrame', 'getNpcKey', 'getProductNumberKey', 'getOeeConfig']),
    ...mapGetters('oeeAnalytics', ['getWorkflowId', 'getSelectedDate', 'getUnit', 'getSelectedDateParsedToString', 'getSelectedProductNumber', 'getQueryFilters', 'getProductionRunData']),
    parsedSelectedDate() {
      return this.filters.selectedDate ? this.filters.selectedDate.format('DD-MM-YY') : ''
    },
    getProductNumbersToView() {
      return _.map(_.uniqBy(this.hardwareLogs, 'productNumber'), 'productNumber').sort();
    },
    getProductNumbersToViewFromRuns() {
      let filter = this.getOeeConfig.activitiesThatActLikeUnscheduledDownTime


      return _.map(_.uniqBy(_.filter(this.getProductionRunData, run => {
        if (filter && !filter.includes(run.activity)) {
          return run
        } else {
          if (!filter) {
            return run
          }
        }
      }), 'productNumber'), 'productNumber').sort();
    },
    getRunIds() {
      return _.map(_.uniqBy(this.hardwareLogs, 'runId'), 'runId');
    },
    getLogs() {
      let logs = this.filters.selectedDate && this.filters.selectedDate.toISOString() ? this.hardwareLogsPerMinute[this.filters.selectedDate.toISOString()] : this.hardwareLogs
      return _.filter(logs, log => {
        if (this.filters.productNumber) {
          return log.productNumber === this.filters.productNumber
        } else {
          return log
        }
      })
    },
  },
  methods: {
    async setSelectedDate(date) {
      this.filters.selectedDate = date
      if (!this.hardwareLogsPerMinute[this.filters.selectedDate.toISOString()]) {
        this.loading = true
        let query = this.getQueryFilters

        query.fromDate = this.filters.selectedDate.toISOString()
        query.toDate = moment(this.filters.selectedDate).endOf('day').toDate().toISOString()
        let hardwareLogs = await this.$FUNCTIONS.OeeAnalytics("getHardwareLogs", {
              ...query,
              groupBy: this.filters.selectedDate ? 'minute' : 'day',
              productNumberKey: this.getProductNumberKey
            }
        ).catch(e => {
          this.loading = false
          return
        })
        this.hardwareLogsPerMinute[this.filters.selectedDate.toISOString()] = hardwareLogs.data
        this.loading = false
      }

    },
    setSelectedProductNumber(event) {
      this.selectedProductNumber = event
      this.$store.commit('oeeAnalytics/setProductNumber', event);
    },
    productNumberSelected(event) {
      this.$store.commit('oeeAnalytics/setProductNumber', event.target.value);
    },
    async getLogsFromBigquery(singleday = false) {
      this.loading = true
      let query = this.getQueryFilters
      if (singleday) {
        query.fromDate = this.filters.selectedDate.toISOString()
        query.toDate = moment(this.filters.selectedDate).endOf('day').toDate().toISOString()
      } else {
        this.hardwareLogs = null
      }
      let hardwareLogs = await this.$FUNCTIONS.OeeAnalytics("getHardwareLogs", {
            ...query,
            groupBy: this.filters.selectedDate ? 'minute' : 'day',
            productNumberKey: this.getProductNumberKey
          }
      ).catch(e => {
        this.loading = false
        return
      })
      if (!singleday) {
        this.hardwareLogs = hardwareLogs ? hardwareLogs.data : null;
      } else {
        this.hardwareLogsPerMinute[this.filters.selectedDate.toISOString()] = hardwareLogs.data
      }
      this.loading = false
      return hardwareLogs
    },


  }
  ,
  watch: {

    updateDataTrigger(newV, oldV) {
      this.getLogsFromBigquery()
    }
  }
  ,
  created() {
    this.getLogsFromBigquery()
  }
  ,

}
</script>

<style scoped>
.oee-controls {
  width: 600px;
}

</style>

<style>
/* Override the height of the porlet head (only if its part of the oee-chart-portlet so it doesnt change anywhere else) */
.oee-chart-portlet > .m-portlet__head {
  height: 10rem !important;
}

.loading {
  opacity: 0.5
}

.loading {
  background-color: #efefef;
  height: 100%;
  width: 100%;
  min-height: 250px;
}

</style>